// Verbatim clinician-designed domain questionnaires (from the mobile app).
export const DOMAIN_QUESTIONS = {
  sleep: {
    title: 'Sleep & Recovery',
    icon: 'fa-moon',
    color: '#6366F1',
    bg: '#E0E7FF',
    questions: [
      { id: 'sleep_time', question: 'What time did you go to bed last night?', type: 'time' },
      { id: 'wake_time', question: 'What time did you wake up this morning?', type: 'time' },
      { id: 'time_to_fall_asleep', question: 'How long did it take you to fall asleep?', type: 'multiselect', options: ['Under 15 mins', '15-30 mins', '30-60 mins', 'Over 1 hour', 'Over 2 hours'] },
      { id: 'woke_during_night', question: 'Did you wake up during the night?', type: 'yesno' },
      { id: 'wake_frequency', question: 'How many times did you wake up?', type: 'multiselect', options: ['Once', 'Twice', '3-4 times', 'More than 4 times', 'Constantly waking'] },
      { id: 'wake_reasons', question: 'What woke you up?', type: 'multiselect', options: ['Needed the toilet', 'Night sweats', 'Hot flushes', 'Anxiety/racing thoughts', 'Pain/discomfort', 'Partner/noise', 'Unknown'] },
      { id: 'night_sweats', question: 'Did you experience night sweats?', type: 'yesno' },
      { id: 'night_sweats_severity', question: 'How severe were the night sweats?', type: 'scale', min: 0, max: 5 },
      { id: 'changed_bedding', question: 'Did you need to change clothes or bedding?', type: 'yesno' },
      { id: 'back_to_sleep', question: 'How easily did you get back to sleep?', type: 'multiselect', options: ['Easily (under 10 mins)', 'Some difficulty (10-30 mins)', 'Struggled (30-60 mins)', 'Could not get back to sleep'] },
      { id: 'sleep_quality', question: 'How would you rate your overall sleep quality?', type: 'scale', min: 0, max: 5 },
      { id: 'feel_rested', question: 'Do you feel rested this morning?', type: 'scale', min: 0, max: 5 },
      { id: 'dreams', question: 'Did you have vivid dreams or nightmares?', type: 'yesno' },
      { id: 'sleep_aids', question: 'Did you use any sleep aids?', type: 'multiselect', options: ['None', 'Melatonin', 'Herbal remedies', 'Prescription medication', 'Alcohol', 'CBD/Cannabis'] },
    ],
  },
  energy: {
    title: 'Energy & Vitality',
    icon: 'fa-bolt',
    color: '#F97316',
    bg: '#FFEDD5',
    questions: [
      { id: 'morning_energy', question: 'How was your energy when you woke up?', type: 'scale', min: 0, max: 5 },
      { id: 'midday_energy', question: 'How is your energy typically by midday?', type: 'scale', min: 0, max: 5 },
      { id: 'afternoon_energy', question: 'How is your energy in the afternoon (2-5pm)?', type: 'scale', min: 0, max: 5 },
      { id: 'evening_energy', question: 'How is your energy in the evening?', type: 'scale', min: 0, max: 5 },
      { id: 'energy_crashes', question: 'Did you experience any energy crashes today?', type: 'yesno' },
      { id: 'crash_time', question: 'When did the energy crash occur?', type: 'multiselect', options: ['Mid-morning', 'After lunch', 'Mid-afternoon', 'Early evening', 'Multiple times'] },
      { id: 'caffeine_intake', question: 'How much caffeine have you had today?', type: 'multiselect', options: ['None', '1 cup coffee/tea', '2-3 cups', '4+ cups', 'Energy drinks'] },
      { id: 'caffeine_time', question: 'When did you have your last caffeine?', type: 'multiselect', options: ['Before 12pm', '12pm-3pm', '3pm-6pm', 'After 6pm'] },
      { id: 'exercise_today', question: 'Did you exercise today?', type: 'yesno' },
      { id: 'exercise_type', question: 'What type of exercise?', type: 'multiselect', options: ['Walking', 'Running/Cardio', 'Strength training', 'Yoga/Pilates', 'Swimming', 'Other'] },
      { id: 'exercise_duration', question: 'How long did you exercise?', type: 'multiselect', options: ['Under 15 mins', '15-30 mins', '30-60 mins', 'Over 1 hour'] },
      { id: 'fatigue_type', question: 'What type of fatigue are you experiencing?', type: 'multiselect', options: ['Physical tiredness', 'Mental exhaustion', 'Both', 'Muscle weakness', 'Heavy limbs'] },
    ],
  },
  hormonal: {
    title: 'Hormonal Transition',
    icon: 'fa-droplet',
    color: '#8B5CF6',
    bg: '#EDE9FE',
    questions: [
      { id: 'hot_flushes_today', question: 'Did you experience hot flushes today?', type: 'yesno' },
      { id: 'flush_count', question: 'How many hot flushes did you have?', type: 'multiselect', options: ['1-2', '3-5', '6-10', 'More than 10', 'Constant'] },
      { id: 'flush_severity', question: 'How severe were the hot flushes?', type: 'scale', min: 0, max: 5 },
      { id: 'flush_duration', question: 'How long did they typically last?', type: 'multiselect', options: ['Under 1 minute', '1-3 minutes', '3-5 minutes', 'Over 5 minutes'] },
      { id: 'flush_triggers', question: 'Did you notice any triggers?', type: 'multiselect', options: ['Stress', 'Hot drinks', 'Alcohol', 'Spicy food', 'Exercise', 'Room temperature', 'No obvious trigger'] },
      { id: 'vaginal_dryness', question: 'Are you experiencing vaginal dryness?', type: 'yesno' },
      { id: 'vaginal_dryness_severity', question: 'How severe is the vaginal dryness?', type: 'scale', min: 0, max: 5 },
      { id: 'vaginal_discomfort', question: 'Any discomfort or irritation?', type: 'multiselect', options: ['None', 'Itching', 'Burning', 'Pain during intercourse', 'General discomfort'] },
      { id: 'libido', question: 'How would you rate your sex drive/libido?', type: 'scale', min: 0, max: 5 },
      { id: 'libido_change', question: 'Has your libido changed recently?', type: 'multiselect', options: ['No change', 'Decreased significantly', 'Decreased slightly', 'Increased slightly', 'Increased significantly'] },
      { id: 'period_status', question: 'What is your current period status?', type: 'multiselect', options: ['Currently on period', 'Due soon', 'Late/irregular', 'Not expected', 'No longer having periods'] },
      { id: 'period_pain', question: 'Are you experiencing period pain?', type: 'scale', min: 0, max: 5 },
      { id: 'breast_tenderness', question: 'Any breast tenderness?', type: 'scale', min: 0, max: 5 },
      { id: 'bloating', question: 'Are you experiencing bloating?', type: 'scale', min: 0, max: 5 },
    ],
  },
  metabolic: {
    title: 'Metabolic Health',
    icon: 'fa-fire',
    color: '#F97316',
    bg: '#FFEDD5',
    questions: [
      { id: 'appetite_today', question: 'How would you describe your appetite today?', type: 'multiselect', options: ['No appetite', 'Reduced', 'Normal', 'Increased', 'Constantly hungry'] },
      { id: 'cravings', question: 'Did you experience any cravings?', type: 'yesno' },
      { id: 'craving_types', question: 'What did you crave?', type: 'multiselect', options: ['Sugar/sweets', 'Carbs/bread', 'Salty foods', 'Fatty foods', 'Chocolate', 'Specific foods'] },
      { id: 'meals_today', question: 'How many meals did you have today?', type: 'multiselect', options: ['1 meal', '2 meals', '3 meals', 'More than 3', 'Grazing/snacking'] },
      { id: 'water_intake', question: 'How much water did you drink?', type: 'multiselect', options: ['Less than 4 glasses', '4-6 glasses', '6-8 glasses', 'More than 8 glasses'] },
      { id: 'bloating_after_meals', question: 'Did you feel bloated after eating?', type: 'yesno' },
      { id: 'digestion', question: 'How was your digestion today?', type: 'multiselect', options: ['Normal', 'Constipation', 'Loose stools', 'Bloating', 'Discomfort', 'Acid reflux'] },
      { id: 'weight_feeling', question: 'How do you feel about your weight today?', type: 'multiselect', options: ['Comfortable', 'Slightly heavy', 'Bloated', 'Lighter than usual', 'Concerned'] },
      { id: 'blood_sugar_symptoms', question: 'Any blood sugar symptoms?', type: 'multiselect', options: ['None', 'Shakiness', 'Irritability when hungry', 'Energy crashes', 'Dizziness', 'Sugar rush then crash'] },
      { id: 'alcohol_yesterday', question: 'Did you drink alcohol yesterday?', type: 'yesno' },
      { id: 'alcohol_amount', question: 'How many units of alcohol?', type: 'multiselect', options: ['1-2 units', '3-4 units', '5-6 units', 'More than 6'] },
    ],
  },
  mental: {
    title: 'Mental Wellbeing',
    icon: 'fa-brain',
    color: '#14B8A6',
    bg: '#CCFBF1',
    questions: [
      { id: 'overall_mood', question: 'How would you rate your overall mood today?', type: 'scale', min: 0, max: 5 },
      { id: 'mood_stability', question: 'How stable has your mood been?', type: 'multiselect', options: ['Very stable', 'Mostly stable', 'Some ups and downs', 'Quite changeable', 'Very unpredictable'] },
      { id: 'anxiety_level', question: 'What is your anxiety level today?', type: 'scale', min: 0, max: 5 },
      { id: 'anxiety_symptoms', question: 'Any anxiety symptoms?', type: 'multiselect', options: ['None', 'Racing thoughts', 'Worry', 'Physical tension', 'Heart palpitations', 'Difficulty breathing', 'Feeling of panic', 'Sense of dread'] },
      { id: 'panic_feelings', question: 'Have you experienced feelings of panic?', type: 'yesno' },
      { id: 'panic_frequency', question: 'How often have you felt panicked?', type: 'multiselect', options: ['Once briefly', 'A few times', 'Multiple times', 'Most of the day', 'Constantly'] },
      { id: 'stress_level', question: 'How stressed are you feeling?', type: 'scale', min: 0, max: 5 },
      { id: 'stress_sources', question: 'Main sources of stress?', type: 'multiselect', options: ['Work', 'Family', 'Health', 'Finances', 'Relationships', 'General overwhelm'] },
      { id: 'brain_fog', question: 'Are you experiencing brain fog?', type: 'yesno' },
      { id: 'brain_fog_severity', question: 'How severe is the brain fog?', type: 'scale', min: 0, max: 5 },
      { id: 'concentration', question: 'How is your concentration today?', type: 'multiselect', options: ['Sharp and focused', 'Mostly good', 'Some difficulty', 'Very distracted', 'Unable to focus'] },
      { id: 'memory_issues', question: 'Any memory issues today?', type: 'multiselect', options: ['None', 'Forgetting words', 'Forgetting tasks', 'Losing things', 'Forgetting conversations'] },
      { id: 'irritability', question: 'How irritable are you feeling?', type: 'scale', min: 0, max: 5 },
      { id: 'crying_spells', question: 'Have you felt tearful or had crying spells?', type: 'yesno' },
      { id: 'motivation', question: 'How is your motivation today?', type: 'scale', min: 0, max: 5 },
      { id: 'loss_of_interest', question: 'Have you lost interest in hobbies or daily activities?', type: 'yesno' },
      { id: 'activities_affected', question: 'Which activities have you lost interest in?', type: 'multiselect', options: ['Hobbies', 'Exercise', 'Socialising', 'Work tasks', 'Household chores', 'Self-care', 'Everything'] },
    ],
  },
  physical: {
    title: 'Physical Wellbeing',
    icon: 'fa-person-walking',
    color: '#EF4444',
    bg: '#FEE2E2',
    questions: [
      { id: 'muscle_aches', question: 'Are you experiencing muscle or body aches?', type: 'yesno' },
      { id: 'ache_severity', question: 'How severe are the aches?', type: 'scale', min: 0, max: 5 },
      { id: 'ache_locations', question: 'Where are you experiencing aches?', type: 'multiselect', options: ['Neck', 'Shoulders', 'Back', 'Hips', 'Knees', 'Joints generally', 'All over'] },
      { id: 'joint_stiffness', question: 'Any joint stiffness?', type: 'yesno' },
      { id: 'stiffness_timing', question: 'When is stiffness worst?', type: 'multiselect', options: ['Morning', 'After sitting', 'After exercise', 'Evening', 'All day'] },
      { id: 'hair_loss', question: 'Are you experiencing hair loss or thinning?', type: 'yesno' },
      { id: 'hair_loss_severity', question: 'How noticeable is the hair loss?', type: 'multiselect', options: ['Slight thinning', 'Moderate thinning', 'Significant loss', 'Bald patches', 'Overall volume loss'] },
      { id: 'dry_skin', question: 'Are you experiencing dry skin?', type: 'yesno' },
      { id: 'skin_areas', question: 'Which areas are affected?', type: 'multiselect', options: ['Face', 'Hands', 'Body', 'Scalp', 'Everywhere'] },
      { id: 'urinary_urgency', question: 'Do you experience urinary urgency (sudden need to go)?', type: 'yesno' },
      { id: 'urinary_frequency', question: 'How often do you need to urinate?', type: 'multiselect', options: ['Normal', 'More than usual', 'Very frequently', 'Constantly feeling the need'] },
      { id: 'stress_incontinence', question: 'Do you leak urine when coughing, sneezing or exercising?', type: 'yesno' },
      { id: 'incontinence_frequency', question: 'How often does leaking occur?', type: 'multiselect', options: ['Rarely', 'Sometimes', 'Often', 'Daily'] },
      { id: 'night_urination', question: 'How many times do you wake to urinate at night?', type: 'multiselect', options: ['Never', 'Once', 'Twice', '3 or more times'] },
      { id: 'headaches', question: 'Are you experiencing headaches?', type: 'yesno' },
      { id: 'headache_frequency', question: 'How often do you get headaches?', type: 'multiselect', options: ['Rarely', 'Weekly', 'Several times a week', 'Daily'] },
      { id: 'headache_severity', question: 'How severe are the headaches?', type: 'scale', min: 0, max: 5 },
      { id: 'headache_type', question: 'What type of headache?', type: 'multiselect', options: ['Tension (band around head)', 'Migraine', 'Cluster', 'Sinus', 'Unsure'] },
    ],
  },
  lifestyle: {
    title: 'Lifestyle Factors',
    icon: 'fa-leaf',
    color: '#EC4899',
    bg: '#FCE7F3',
    questions: [
      { id: 'overall_day', question: 'How would you rate your day overall?', type: 'scale', min: 0, max: 5 },
      { id: 'work_life_balance', question: 'How is your work-life balance?', type: 'scale', min: 0, max: 5 },
      { id: 'smoking_status', question: 'Do you smoke or vape?', type: 'multiselect', options: ['Non-smoker', 'Ex-smoker', 'Occasional smoker', 'Regular smoker', 'Vaper'] },
      { id: 'smoking_amount', question: 'How many cigarettes/vapes per day?', type: 'multiselect', options: ['1-5', '6-10', '11-20', 'More than 20', 'Not applicable'] },
      { id: 'screen_time', question: 'How much screen time before bed?', type: 'multiselect', options: ['None', 'Under 30 mins', '30-60 mins', '1-2 hours', 'More than 2 hours'] },
      { id: 'outdoor_time', question: 'Did you spend time outdoors today?', type: 'yesno' },
      { id: 'outdoor_duration', question: 'How long were you outside?', type: 'multiselect', options: ['Under 15 mins', '15-30 mins', '30-60 mins', 'Over 1 hour'] },
      { id: 'social_interaction', question: 'Did you have meaningful social interactions?', type: 'yesno' },
      { id: 'relaxation_time', question: 'Did you take time to relax today?', type: 'yesno' },
      { id: 'relaxation_activities', question: 'What relaxation did you do?', type: 'multiselect', options: ['Reading', 'Meditation', 'Bath/shower', 'TV/streaming', 'Hobbies', 'Nothing specific'] },
      { id: 'stress_management', question: 'Did you do anything to manage stress?', type: 'multiselect', options: ['Exercise', 'Deep breathing', 'Meditation', 'Talking to someone', 'Journaling', 'Nothing'] },
      { id: 'self_care', question: 'Did you practice self-care today?', type: 'yesno' },
      { id: 'hydration', question: 'How well did you stay hydrated?', type: 'scale', min: 0, max: 5 },
    ],
  },
};

// Dashboard cards order
export const DOMAIN_ORDER = ['sleep', 'energy', 'hormonal', 'metabolic', 'mental', 'physical', 'lifestyle'];

export const STAGE_LABEL = {
  pre: 'Pre-menopause',
  peri: 'Perimenopause',
  post: 'Post-menopause',
  'n/a': 'N/A',
};

export const SERVICE_TIERS = [
  {
    key: 'balance',
    name: 'Balance',
    price: '£95',
    cadence: 'per consultation',
    tagline: 'Understand what is happening',
    color: '#14B8A6',
    features: ['45-min clinician consultation', 'Symptom pattern review', 'Personalised lifestyle plan', 'Written summary'],
  },
  {
    key: 'horizon',
    name: 'Horizon',
    price: '£240',
    cadence: 'assessment + review',
    tagline: 'Precision biomarker insight',
    color: '#7C3AED',
    popular: true,
    features: ['Everything in Balance', 'Biomarker panel + AI analysis', 'Hormonal & metabolic deep-dive', '6-week follow-up review'],
  },
  {
    key: 'thrive',
    name: 'Thrive',
    price: '£55',
    cadence: 'per month',
    tagline: 'Ongoing precision care',
    color: '#EC4899',
    features: ['Ongoing monitoring & check-ins', 'Priority clinician messaging', 'Quarterly biomarker reviews', 'Prescription management'],
  },
];

// Biomarker panels for input screen
export const BIOMARKER_PANELS = [
  { key: 'Thyroid', markers: ['tsh', 'free_t4', 'free_t3'] },
  { key: 'Hormone', markers: ['estradiol', 'progesterone', 'fsh', 'lh', 'testosterone', 'dhea_s'] },
  { key: 'Metabolic', markers: ['fasting_glucose', 'hba1c', 'insulin'] },
  { key: 'Iron', markers: ['ferritin', 'iron', 'tibc'] },
  { key: 'Vitamins', markers: ['vitamin_d', 'vitamin_b12', 'folate'] },
  { key: 'Lipids', markers: ['total_cholesterol', 'ldl', 'hdl', 'triglycerides'] },
  { key: 'Inflammation', markers: ['crp', 'cortisol_am'] },
];

export const STATUS_STYLE = {
  elevated: { label: 'Elevated', color: '#EF4444', bg: 'rgba(239,68,68,0.12)' },
  active: { label: 'Active', color: '#EF4444', bg: 'rgba(239,68,68,0.12)' },
  moderate: { label: 'Moderate', color: '#F59E0B', bg: 'rgba(245,158,11,0.12)' },
  emerging: { label: 'Emerging', color: '#F59E0B', bg: 'rgba(245,158,11,0.12)' },
  low: { label: 'Stable', color: '#10B981', bg: 'rgba(16,185,129,0.12)' },
  stable: { label: 'Stable', color: '#10B981', bg: 'rgba(16,185,129,0.12)' },
};
